/* eslint-disable react/button-has-type */
import { type ButtonHTMLAttributes } from 'react';
import classnames from 'classnames';
import Loading from './Loading';
import styles from './Button.module.scss';

export const colorToClassNameMap: Record<string, string | undefined> = {
  primary: styles.primary,
  transparent: styles.transparent,
  secondary: styles.secondary,
  danger: styles.danger,
};

export interface IButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  color?: string;
  loading?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

export default function Button({
  children,
  className,
  disabled,
  color,
  loading,
  type = 'button',
  onClick,
  ...rest
}: IButtonProps) {
  return (
    <button
      className={classnames(styles.btn, colorToClassNameMap[String(color)], className)}
      type={type}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      <div style={{ visibility: loading ? 'hidden' : 'visible' }}>{children}</div>
      {loading ? (
        <div className={styles.btnLoading}>
          <Loading size={25} color="#fff" />
        </div>
      ) : null}
    </button>
  );
}
